import axios, { AxiosError } from 'axios'
import { message } from 'antd'
import i18n from '../i18n/config'
import { getLocalizedApiErrorMessage } from './apiErrorI18n'
import { isHandledUnauthorizedError } from './authErrorMarker'
export { isHandledUnauthorizedError, markHandledUnauthorizedError } from './authErrorMarker'

export const handleApiError = (
    error: unknown
): { message: string; details?: unknown } => {
    if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{
            detail?: string
            message?: string
        }>

        if (axiosError.response?.status === 401) {
            return {
                message: i18n.t('errors:auth.sessionExpired', {
                    defaultValue: '登录已过期，请重新登录',
                }),
                details: axiosError.response?.data,
            }
        }

        const errorMessage = getLocalizedApiErrorMessage(
            error,
            axiosError.response?.data?.message ||
                i18n.t('errors:general.operationFailed', {
                    defaultValue: '操作失败',
                }),
            i18n.t.bind(i18n)
        )

        return { message: errorMessage, details: axiosError.response?.data }
    }

    const errorMessage =
        error instanceof Error && !/[A-Za-z]/.test(error.message)
            ? error.message
            : i18n.t('errors:general.unknownError', {
                  defaultValue: '未知错误',
              })
    return { message: errorMessage, details: error }
}

export const showErrorMessage = (error: unknown): void => {
    if (isHandledUnauthorizedError(error)) {
        return
    }
    const { message: errorMessage } = handleApiError(error)
    message.error(errorMessage)
}
